import { render, staticRenderFns } from "./YourCountOfCurrentBadgesDashboardCard.vue?vue&type=template&id=12c2e790&scoped=true"
import script from "./YourCountOfCurrentBadgesDashboardCard.vue?vue&type=script&setup=true&lang=js"
export * from "./YourCountOfCurrentBadgesDashboardCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./YourCountOfCurrentBadgesDashboardCard.vue?vue&type=style&index=0&id=12c2e790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c2e790",
  null
  
)

export default component.exports